import React, { useState } from 'react'
import Image from 'next/image'

import { KEY_VALUES } from '../../constants'
import { COLORS } from '../../styles'
import ImageWithBlurryPlaceholder from '../ImageWithBlurryPlaceholder'

import Styled from './RecipePoster.styled'

const RecipePoster = ({
  backgroundColor,
  backgroundPatternUrl,
  className,
  imageUrl,
  onPlayClick,
  title,
}) => {
  const [imageLoaded, setImageLoaded] = useState(false)
  return (
    <Styled className={className}>
      <Styled.container>
        <Styled.patternBakground backgroundColor={backgroundColor}>
          {backgroundPatternUrl ? (
            <Styled.patternContainer>
              <Image
                src={backgroundPatternUrl}
                fill
                style={{ objectFit: 'cover', objectPosition: 'top center' }}
                alt=""
                priority={false}
              />
            </Styled.patternContainer>
          ) : null}
        </Styled.patternBakground>

        <Styled.recipeImageContainer>
          <Styled.recipeImage imageLoaded={imageLoaded}>
            {imageUrl ? (
              <ImageWithBlurryPlaceholder
                alt={title}
                onLoad={() => setImageLoaded(true)}
                placeholderColor={backgroundColor}
                sizes="100vh"
                src={imageUrl}
                title={title}
                priority={true}
              />
            ) : null}
          </Styled.recipeImage>
        </Styled.recipeImageContainer>

        {onPlayClick ? (
          <Styled.videoPlay
            role="button"
            tabIndex={0}
            onKeyPress={(event) => {
              if (event.key === KEY_VALUES.ENTER) {
                onPlayClick()
              }
            }}
            onClick={onPlayClick}
          >
            <Styled.videoPlayButton>
              <Styled.videoPlayButtonIcon
                name="play-fill-32"
                width={36}
                height={36}
                fill={COLORS.white}
              />
            </Styled.videoPlayButton>
          </Styled.videoPlay>
        ) : null}
      </Styled.container>
    </Styled>
  )
}

RecipePoster.defaultProps = {
  backgroundPatternUrl: '',
  imageUrl: '',
  shape: 'circular',
}

export default RecipePoster
